'use strict';
{
    var app = angular.module('tf.filters', [])

        // Calculate the number of partial weeks since the start of the month until now
        .filter("tfWeekOfMonth", function() {
            return function(date) {
                return (+(moment(date).date() / 7).toFixed(0)) + 1;
            }
        })

        .filter("liquidity", function() {
            return function(input) {
                switch (input) {
                    case "NONE":
                        return "None";
                    case "BAD":
                        return "Limited";
                    case "AVERAGE":
                        return "Ok";
                    case "GOOD":
                        return "Good";
                    case "TOTAL":
                        return "Excellent";
                    default:
                        return input;
                }
            }
        })

        .filter("asxDate", function() {
             return function (input) {
                if (input == null) {
                    return null;
                }

                return moment(input).tz("Australia/Sydney").format("DD/MM/YYYY");
            }
        })

        .filter("omDate", function() {
             return function (input) {
                if (input == null) {
                    return null;
                }

                return moment(input).format("DD/MM/YYYY");
            }
        })

        .filter('daysFromNow', function() {
            return function(input, to) {
                var now = to || moment().startOf('day');
                var then = moment(input).startOf('day');

                var duration = moment.duration(then.diff(now));

                return Math.round(duration.asDays());

            }
        })

        .filter("closedReason", function() {
            return function(input) {
                switch (input) {
                    case "EXPIRED":
                        return "Expired";
                    case "FILLED":
                        return "Filled";
                    case "CANCELLED":
                        return "Cancelled";
                    case "FAILED":
                        return "Failed";
                    default:
                        return input;
                }
            };
        })

        .filter('orderStatus', function() {
            return function(input) {
                if (input === "PENDING") {
                    return "Pending";
                } else if (input === "ON_MARKET") {
                    return "Working";
                } else if (input === "WAITING_OPERATOR") {
                    return "Waiting Operator";
                } else if (input === "DONE") {
                    return "Done";
                } else {
                    return input;
                }

            };
        })

        .filter('greet', function() {
            return function(input) {
                if (input < 12) {
                    return 'Good Morning';
                } else if (input >= 12 && input <= 17) {
                    return 'Good Afternoon';
                } else if (input > 17 && input <= 24) {
                    return 'Good Evening';
                } else {
                    return "I'm not sure what time it is!";
                }
            };
        })

        .filter('sumOfValue', function () {
            return function (data, key) {

                if (angular.isUndefined(data) && angular.isUndefined(key))
                    return 0;
                var sum = 0;

                angular.forEach(data,function(v,k){
                    sum = sum + parseInt(v[key]);
                });
                return sum;
            }
        })

        .filter('totalSumPriceQty', function () {
            return function (data, key1, key2) {
                if (angular.isUndefined(data) && angular.isUndefined(key1)  && angular.isUndefined(key2))
                    return 0;

                var sum = 0;
                angular.forEach(data,function(v,k){
                    sum = sum + (parseInt(v[key1]) * parseInt(v[key2]));
                });
                return sum;
            }
        })

        .filter('ordinal', ['$window', function($window) {
            return function (n) {
                return suffix(n);

            };

            function suffix(numberOrString) {
                const n = +numberOrString;
                return $window.Math.floor(n / 10) === 1
                    ? 'th'
                    : (n % 10 === 1
                    ? 'st'
                    : (n % 10 === 2
                    ? 'nd'
                    : (n % 10 === 3
                    ? 'rd'
                    : 'th')))
            }
        }])

        .filter('abs', ['$window', function($window) {
            return function(n) {
                if(n == null) {
                    return null
                } else {
                    return $window.Math.abs(n);
                }
            };
        }])

        .filter('style', function() {
            return function(input) {
                if (input == 'AMERICAN') {
                    return 'A';
                } else if (input == 'EUROPEAN') {
                    return 'E';
                } else if (input == 'FUTURE') {
                } else {
                    return input;
                }
            }
        })

        .filter('type', function() {
            return function(input) {
                if (input == 'PUT') {
                    return 'Put';
                } else if (input == 'CALL') {
                    return 'Call';
                } else if (input == 'FUTURE') {
                    return 'Future';
                } else {
                    return input;
                }
            }
        })

        .filter('product', function() {
            return function(input) {
                if (input == 'OPTION_OVER_SHARES') {
                    return 'ETO';
                } else if (input == 'OPTION_OVER_INDEX') {
                    return 'INDEX';
                } else {
                    return input;
                }
            }
        })

        .filter('change', function() {
            return function(input, points) {
                if (input === undefined || input === null) {
                    return '';
                }
                input = +input;
                return (input >= 0 ? '+' : '') + input.toFixed(points || true ? 0 : 3);
            }
        })

        .filter('numberFixed', function() {
            var pad = function pad(string, width) {
                return string.length >= width ? string : new Array(width - string.length + 1).join('\u2007') + string;
            };

            var formatNumber = function(number) {
                if (number < 0) {
                    return "\u2212" + Math.abs(number);
                } else {
                    return "" + number;
                }
            };


            return function(input, padding, isChange) {
                if (isChange) {
                    return pad("(" + formatNumber(input) + ")", padding || 7);
                } else {
                    return pad("" + formatNumber(input), padding || 5);
                }
            }
        })

        .filter('price', function() {
            return function(input, points) {
                if (input === undefined || input === null) {
                    return '';
                }

                return points ? input.toFixed(1) : input.toFixed(3);
            }
        })

        .filter('priceInCents', ['userConfig', function(userConfig) {
            const filter = function (input, points, decimalPlaces = 3) {
                if (input === undefined || input === null) {
                    return '';
                }

                if (points) {
                    return input.toFixed(1);
                }

                const priceInCents = !!userConfig.preferences.priceInCents;

                if (priceInCents) {
                    return (input * 100).toFixed(decimalPlaces - 2);
                } else {
                    return input.toFixed(decimalPlaces)
                }
            };

            filter.$stateful = true;

            return filter;
        }])

        .filter('strategyPrice', function () {
            const filter = function (input, strategy, skipInvalidValues) {
                if (input == null || strategy == null) {
                    return null;
                } else {
                    return strategy.format(input, skipInvalidValues);
                }
            };

            filter.$stateful = true;

            return filter;
        })

        .filter('strike', function() {
            return function(input, points) {
                if (input === undefined || input === null) {
                    return '';
                }

                return points ? input.toFixed(0) : input.toFixed(3);
            }
        })

        .filter('points', function() {
            return function(input) {
                if (input === undefined || input === null) {
                    return '';
                }

                return input.toFixed(1);
            }
        })

        .filter('ledger', ['$filter', function($filter) {
            var numberFormat = $filter('number');

            return function(input, decimals) {
                if (input === undefined || input === null) {
                    return '';
                }

                decimals = decimals || 0;
                return input < 0 ?
                "($" + numberFormat(-input, decimals) + ")" :
                "$" + numberFormat(input, decimals);
            }
        }])

        .filter('tfcurrency', ['$filter', function($filter) {
            var numberFormat = $filter('number');

            return function(input, decimals) {
                if (input === undefined || input === null) {
                    return '';
                }

                decimals = decimals || 0;

                return input < 0 ?
                "-$" + numberFormat(-input, decimals) :
                "$" + numberFormat(input, decimals) ;
            }
        }])

        .filter('tfDebitCredit', ['$filter', function ($filter) {

            var format = $filter('tfcurrency');

            return function (input, decimals, inverse) {
                var negative = input < 0;
                if (inverse) {
                    negative = !negative;
                }

                input = Math.abs(input);
                var value = format(input, decimals);
                return value + (negative ? " DR" : " CR" );
            }
        }])

        .filter('modified', function() {
            return function(input, scenario, securityOnly) {
                if (input === undefined || input === null) {
                    return '';
                }

                if (scenario != null) {
                    for (var i = 0; i < scenario.securityScenarios.length; i++) {
                        var securityScenario = scenario.securityScenarios[i];
                        if (securityScenario.security === input) {

                            if (securityScenario.price) {
                                if (securityScenario.priceType == '%') {
                                    return input + ' ' +
                                        (securityScenario.price > 0 ? '+' : '') +
                                        (securityScenario.price * 100).toFixed(1) + "%";
                                } else if (securityScenario.priceType == '$') {
                                    return input + ' ' +
                                        (securityScenario.price > 0 ? '+' : '') +
                                        (securityScenario.price).toFixed(2);
                                } else if (securityScenario.priceType == '@') {
                                    return input + ' @ ' + (securityScenario.price).toFixed(2);
                                }
                            }

                            return input;
                        }
                    }

                    if (!securityOnly && scenario.marketScenario) {
                        if (scenario.marketScenario.price && scenario.marketScenario.priceType == '%') {
                            return input + ' ' +
                                (scenario.marketScenario.price > 0 ? '+' : '') +
                                (scenario.marketScenario.price * 100).toFixed(1) + "%";
                        }
                    }
                }

                return input;
            }
        })
         .filter('gicsTranslation', [function() {
             return function (input) {
                 if (input == null) {
                     return null;
                 }
                 return "gics." + input;
             }
         }])
        .filter('gics', [function() {
            return function(input) {
                switch(input) {
                    case "0000": return "GICS Sector Code Not Applicable";
                    case "1010": return "Energy";
                    case "1510": return "Materials";
                    case "2010": return "Capital Goods";
                    case "2020": return "Commercial & Professional Services";
                    case "2030": return "Transportation";
                    case "2510": return "Automobiles & Components" ;
                    case "2520": return "Consumer Durables & Apparel";
                    case "2530": return "Consumer Services";
                    case "2540": return "Media"; //Probably deprecated
                    case "2550": return "Retailing";
                    case "3010": return "Food & Staples Retailing";
                    case "3020": return "Food, Beverage & Tobacco";
                    case "3030": return "Household & Personal Products";
                    case "3510": return "Health Care Equipment & Services";
                    case "3520": return "Pharmaceuticals, Biotechnology & Life Sciences";
                    case "4010": return "Banks";
                    case "4020": return "Diversified Financials";
                    case "4030": return "Insurance";
                    case "4040": return "Real Estate"; //Probably deprecated new code 6010
                    case "4510": return "Software & Services";
                    case "4520": return "Technology Hardware & Equipment";
                    case "4530": return "Semiconductors & Semiconductor Equipment";
                    case "5010": return "Telecommunication Services";
                    case "5020": return "Media & Entertainment";
                    case "5510": return "Utilities";
                    case "6010": return "Real Estate";
                    case "9999": return "Classification Pending";
            }
        }}])

        .filter('percentage', ['$filter', function ($filter) {
            return function (input, decimals) {
                if (input === undefined || input === null) {
                    return '';
                }

                return $filter('number')(input * 100, decimals) + '%';
            }
        }])

        .filter('days', ['$filter', function($filter) {
            return function(input, baseDate) {
                var tmpBaseDate = new Date(baseDate);
                tmpBaseDate.setHours(0);
                tmpBaseDate.setMinutes(0);
                tmpBaseDate.setSeconds(0);
                tmpBaseDate.setMilliseconds(0);

                var tmpInput = new Date(input);
                tmpInput.setHours(0);
                tmpInput.setMinutes(0);
                tmpInput.setSeconds(0);
                tmpInput.setMilliseconds(0);

                var oneDay = 24 * 60 * 60 * 1000;
                var daysDifference = Math.round((tmpInput.getTime() - tmpBaseDate.getTime()) / oneDay);

                return daysDifference + 'd';
            }
        }])

        .filter('debug', function () {
            return function(value) {
                debugger;
                return value;
            }
        })

        .filter('titlecase', function() {
            return function (input) {
                if (input == null) {
                    return null;
                }
                var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;

                input = input.toLowerCase();
                input = input.replace(/_/, " ");
                return input.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
                    if (index > 0 && index + match.length !== title.length &&
                        match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" &&
                        (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
                        title.charAt(index - 1).search(/[^\s-]/) < 0) {
                        return match.toLowerCase();
                    }

                    if (match.substr(1).search(/[A-Z]|\../) > -1) {
                        return match;
                    }

                    return match.charAt(0).toUpperCase() + match.substr(1);
                });
            }
        })

        .filter("otherwise", function () {
            return function (input, defaultVal) {
                if (input == null || input === "") {
                    return defaultVal
                } else {
                    return input
                }
            }
        })
}
